import { Theme } from "common";

export const applicantFiltersStyles = {
  formControlLabel: {
    marginLeft: "5px",
  },
  checkBoxWrapper: {
    marginBottom: "15px",
  },
  formControlLabelRoot: {
    marginLeft: "0px",
    "&&": {
      "& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1": {
        color: Theme.palette.grey[700],
      },
    },
  },
  checkBoxRoot: {
    border: Theme.palette.grey[500],
    backgroundColor: Theme.palette.common.white,
    "& .MuiSvgIcon-root": {
      fill: "gray",
      backgroundColor: Theme.palette.common.white,
      border: Theme.palette.grey[500],
    },
  },
};
